import React, { useEffect, useState } from "react";
import { Menu, Modal } from "antd";
import type { MenuInfo } from "rc-menu/lib/interface";
import AdminForm from "../../workers/admin-details-form/AdminForm";
import RoleForm from "./RoleForm";
interface RoleMenuProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onMenuClick: () => void;
  setModalVisible?: any;
}

const RoleMenu: React.FC<RoleMenuProps> = ({
  onMenuClick,
  setModalVisible,
}) => {
  const [cardTitle, setCardTitle] = useState("");
  const [roleType, setRoleType] = useState("");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const handleMenuClick = (e: MenuInfo) => {
    switch (e.key) {
      case "addUser":
        setCardTitle("User");
        setRoleType("User");
        onMenuClick();
        setIsModalVisible(true);
        break;
      case "addClinicalAdmin":
        setCardTitle("Clinical Admin");
        setRoleType("ClinicalAdmin");
        onMenuClick();
        setIsModalVisible(true);

        break;
      case "addDoctor":
        onMenuClick();
        setCardTitle("Doctor");
        setRoleType("Doctor");
        setIsModalVisible(true);

        break;
      case "addNurse":
        onMenuClick();
        setCardTitle("Nurse");
        setRoleType("Nurse");
        setIsModalVisible(true);

        break;
      default:
        break;
    }
    const handleCancel = (): void => {
      setIsModalVisible(false);
    };
  };

  const handleCancel = (): void => {
    setIsModalVisible(false);
  };
  const renderForm = (): React.ReactNode => {
    switch (cardTitle) {
      case "User":
        return (
          <RoleForm
            onCancel={handleCancel}
            cardTitle={cardTitle}
            roleType={roleType}
            mutationType="add"
            setModalVisible={setModalVisible}
          />
        );
      case "Doctor":
        return (
          <RoleForm
            onCancel={handleCancel}
            mutationType="add"
            cardTitle={cardTitle}
            roleType={roleType}
            setModalVisible={setModalVisible}
          />
        );
      case "Clinical Admin":
        return (
          <RoleForm
            onCancel={handleCancel}
            mutationType="add"
            cardTitle={cardTitle}
            roleType={roleType}
            setModalVisible={setModalVisible}
          />
        );
      case "Nurse":
        return (
          <RoleForm
            onCancel={handleCancel}
            mutationType="add"
            cardTitle={cardTitle}
            roleType={roleType}
            setModalVisible={setModalVisible}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Menu onClick={handleMenuClick} mode="vertical" selectedKeys={[]}>
        <Menu.Item key="addUser" className="delete_message">
          Add User
        </Menu.Item>
        <Menu.Item key="addClinicalAdmin" className="delete_message">
          Add Clinical Admin
        </Menu.Item>
        <Menu.Item key="addDoctor" className="delete_message">
          Add Doctor
        </Menu.Item>
        <Menu.Item key="addNurse" className="delete_message">
          Add Nurse
        </Menu.Item>
      </Menu>
      <Modal
        title={<span className="dynamic-modal">Add {cardTitle}</span>}
        visible={isModalVisible}
        onCancel={handleCancel}
        destroyOnClose={true}
        footer={null}
        width={800}
      >
        {renderForm()}
      </Modal>
    </>
  );
};

export default RoleMenu;
